<template>
  <div class="bg-surface-canvas dark:bg-surface-level-900">
    <NavigationLanding />

    <slot />

    <Footer />
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from '~/stores/useUserStore'
import { useIdentity } from '~/composables/useIdentity'

defineSlots<{
  default?: () => unknown
}>()

const { isAuthenticated } = useIdentity()
const userStore = useUserStore()

// Fetch on mount if already authenticated
onMounted(async () => {
  if (isAuthenticated.value && !userStore.initialized) {
    await userStore.fetchUserAccess()
  }
})

// Also watch for auth becoming true (handles race when redirect happens before Sanctum hydrates)
watch(
  isAuthenticated,
  async (authenticated) => {
    if (authenticated && !userStore.initialized) {
      await userStore.fetchUserAccess()
    }
  },
  { immediate: false }
)
</script>
